 import { v4 as uuid } from 'uuid';

export class Id {
  static gen(): string {
    return new Id().value;
  }
  constructor(public readonly value = uuid()) {} 
}
